export function detectPropertyIndent(content: string, objectStart: number): string {
  const lineStart = content.lastIndexOf('\n', objectStart) + 1
  const baseIndent = content.slice(lineStart, objectStart).match(/^\s*/)?.[0] ?? ''
  const body = content.slice(objectStart + 1)
  const propIndent = body.match(/\n([ \t]+)\S/)

  return propIndent?.[1] ?? `${baseIndent}  `
}
